import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import OvSnackbar from './OvSnackbar';
import { DeleteVideoAction } from '../../../common/model/type/video-placement.types';

interface OvVideoDeletedSnackbarProps {
  action: DeleteVideoAction | null;
  onClose: () => void;
}

const OvVideoDeletedSnackbar: FC<OvVideoDeletedSnackbarProps> = ({
  action,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <OvSnackbar
      isOpen={!!action}
      onClose={onClose}
      severity="success"
      message={
        action === 'archive'
          ? t('videos.delete.archived')
          : t('videos.delete.deleted')
      }
    />
  );
};

export default OvVideoDeletedSnackbar;
